import { SPEC, PROPS, VIEW, DATASOURCES } from '../constants';

export type DashboardJson = {
  name?: string;
  title?: string;
  description?: string;
  tags?: unknown[] | (string | { [key: string]: unknown })[];
  showPageTitle?: boolean;
  globals?: Record<string, unknown>;
  templates?: ReadonlyArray<DashboardJson>;
  [SPEC]?: {
    [PROPS]?: Record<string, unknown>;
    [VIEW]?: string | unknown[];
    [DATASOURCES]?: unknown[] | Record<string, Datasource>;
    [key: string]: unknown;
  };
  [key: string]: unknown;
};

export class Dashboard {
  json: DashboardJson;

  constructor(json: DashboardJson) {
    this.json = json;
  }

  getName(): string | undefined {
    return this.json?.name;
  }

  getSpec(): string | undefined {
    return this.json?.[SPEC]?.toString();
  }

  getTitle(): string | undefined {
    return this.json?.title ?? this.json?.name;
  }

  getTags(): (string | { [key: string]: unknown })[] {
    return (this.json?.tags as (string | { [key: string]: unknown })[]) ?? [];
  }

  getTemplates(): ReadonlyArray<DashboardJson> {
    return this.json?.templates ?? [];
  }
}

export interface Datasource {
  type: string;
  options: Record<string, unknown>;
  enabled?: string | boolean;
  [key: string]: unknown;
}

export interface ExpressionJson {
  jsonata: string;
  description?: string;
  dataSources?: string[];
}

export interface DemoDatasourcesProps {
  datasources: Record<string, Datasource>;
}
export interface EventData {
  currentTarget: {
    attributes: Record<string, string | null>;
    value?: string;
  };
}
